import React from "react";
import { Modal, Spin } from "antd";

const CustomModal = (props) => {
  const { open, hideModal, performAction, title, loading } = props;
  return (
    <Modal
      title="Confirmation"
      open={open}
      onOk={performAction}
      onCancel={hideModal}
      okText={loading ? <span><Spin size="small" /> Deleting...</span> : "Ok"}
      cancelText="Cancel"
      width={window.innerWidth < 768 ? '90%' : 416}
      className="responsive-modal"
      okButtonProps={{ disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <p className="text-sm md:text-base">{title}</p>
      {loading && <p className="text-sm text-gray-500 mt-2">Please wait while we process your request...</p>}
    </Modal>
  );
};

export default CustomModal;
